import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

const COPY = {
  rankings: {
    eyebrow: "Rankings",
    title: "Mining company rankings are coming soon.",
    body:
      "We are finalizing the ranking methodology and data coverage before publishing this tool.",
  },
  screener: {
    eyebrow: "Screener",
    title: "The mining stock screener is coming soon.",
    body:
      "We are preparing the screener workspace for production release.",
  },
};

export default function ProductPlaceholderPage({ type = "rankings" }) {
  const copy = COPY[type] || COPY.rankings;

  return (
    <Container maxWidth="md" sx={{ py: { xs: 7, md: 10 } }}>
      <Box
        sx={{
          border: "1px solid rgba(15, 23, 42, 0.12)",
          borderRadius: 2,
          backgroundColor: "background.paper",
          p: { xs: 3, md: 5 },
        }}
      >
        <Stack spacing={2.5} alignItems="flex-start">
          <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 800 }}>
            {copy.eyebrow}
          </Typography>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 850, fontSize: { xs: 34, md: 48 } }}>
            {copy.title}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 640, lineHeight: 1.75 }}>
            {copy.body}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} sx={{ pt: 1 }}>
            <Button component={RouterLink} to="/companies" variant="contained">
              Browse Companies
            </Button>
            <Button component={RouterLink} to="/contact" variant="outlined">
              Contact Us
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}
